/*
 * The components that can be used on a custom toolbar.
 */

// TODO: remove jquery from here and from webpack config once CONFDEV-52616 is done.
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import window from 'window-or-global';

export default function () {
	const CustomToolbarComponents = {};

	/**
	 * options:
	 *  @param text the text for the button
	 *  @param iconClass the CSS class for the icon on the button
	 *  @param click the click function for the button
	 *  @param disabled true if the button should default to disabled.
	 */
	CustomToolbarComponents.Button = function (options) {
		const text = options.text;
		const tooltip = options.tooltip;
		const triggerText = options.triggerText;
		const iconClass = options.iconClass;
		const click = options.click;
		const disabled = !!options.disabled;
		const id = options.id;

		/**
		 * Create and return a visual representation of this component.
		 */
		this.render = () => {
			const button = $('<button type="button"></button>')
				.addClass('aui-button')
				.attr('data-tooltip', tooltip || text);
			if (id) {
				button.attr('id', id);
			}

			if (disabled) {
				button.prop('disabled', true).attr('aria-disabled', 'true');
			}

			button.click(() => {
				if (!button.prop('disabled')) {
					click();
				}
			});

			if (iconClass) {
				const span = $('<span />');
				span.addClass(`icon ${iconClass}`);
				span.text(text);
				button.append(span);
			}

			if (triggerText) {
				const triggerSpan = $('<span />');
				triggerSpan.addClass('trigger-text');
				triggerSpan.text(triggerText);
				button.append(triggerSpan);
			}

			return button[0];
		};
	};

	/**
	 * options:
	 *  @param id id of the control
	 *  @param text the text for the button
	 *  @param iconClass the CSS class for the icon on the button
	 *  @param disabled true if the button should default to disabled.
	 *  @param dropDownContent markup or element for inserting into the dropDownContainer;
	 */
	CustomToolbarComponents.DropDownButton = function (options) {
		const id = options.id;
		const tooltip = options.tooltip;
		const text = options.text || '';
		const iconClass = options.iconClass;
		const disabled = !!options.disabled;
		const dropDownContent = options.dropDownContent;

		let dropDownContainer;

		/**
		 * Create and return a visual representation of this component.
		 */
		this.render = function () {
			const li = $('<div></div>')
				.addClass('toolbar-item')
				.addClass('toolbar-dropdown')
				.attr('data-tooltip', tooltip);
			li.attr('id', id);
			const parent = $('<div/>').addClass('aui-dd-parent');
			const a = $("<a href='#'></a>");
			a.addClass('toolbar-trigger').addClass('aui-dd-trigger').addClass('aui-button');
			text && a.append(`<span class='dropdown-text'>${text}</span>`);

			if (disabled) {
				li.addClass('disabled');
				a.addClass('disabled');
			}

			if (iconClass) {
				const span = $('<span />');
				span.addClass(`icon ${iconClass}`);
				span.text(text);
				a.append(span);
			}

			const dropDownIcon = $('<span/>');
			dropDownIcon.addClass('icon').addClass('icon-dropdown');
			a.append(dropDownIcon);

			dropDownContainer = $('<div/>').addClass('hidden').addClass('aui-dropdown');
			if (dropDownContent) {
				dropDownContainer.append(dropDownContent);
			}

			parent.append(a);
			parent.append(dropDownContainer);
			li.append(parent);

			return li[0];
		};
	};

	/**
	 * options:
	 *  @param text the text for the button
	 *  @param click the click function for the button
	 *  @param disabled true if the button should default to disabled.
	 *  @param textClass the css class for the button text
	 */
	CustomToolbarComponents.TextButton = function (options) {
		const text = options.text;
		const textClass = options.textClass;
		const click = options.click;
		const disabled = !!options.disabled;
		const tooltip = options.tooltip;

		/**
		 * Create and return a visual representation of this component.
		 */
		this.render = () => {
			const button = $('<button type="button"></button>')
				.addClass('aui-button')
				.addClass(textClass)
				.text(text);
			if (tooltip) {
				button.attr('data-tooltip', tooltip);
			}

			if (disabled) {
				button.prop('disabled', true).attr('aria-disabled', 'true');
			}

			button.click(() => {
				if (!button.prop('disabled')) {
					click();
				}
			});

			return button[0];
		};
	};

	/**
	 * options:
	 * @param id the id for the text box (should be unique)
	 * @param text the title for the text box (should be i18n)
	 * @param name the name for the text box (should not be i18n)
	 * @param keydown the keydown function
	 * @param cssClass the css class
	 */
	CustomToolbarComponents.TextBox = function (options) {
		const id = options.id;
		const text = options.text;
		const name = options.name;
		const keydown = options.keydown;
		const cssClass = options.cssClass;

		this.render = function () {
			const div = $('<div></div>').addClass('toolbar-item');
			div.append($(`<label for="${id}">${text}</label>`));
			const input = $(
				`<input id="${id}" type='text' name="${name}" class="${cssClass} text" autocomplete="off">`,
			);
			input.keydown((e) => {
				keydown(e);
			});

			div.append(input);
			return div[0];
		};
	};

	/**
	 * Create a group of other controls. This group will be visually separate from other groups.
	 *
	 * @param contents an array of other components that should be in this group. (Don't nest groups.)
	 * @param options optional parameters for the group:
	 *   @param id the id for the group
	 *   @param groupClass the class for the group
	 */
	CustomToolbarComponents.Group = function (contents, options) {
		const components = contents;

		/**
		 * Create and return the visual representation of the spacer.
		 */
		this.render = function () {
			const group = $('<div></div>');
			group.addClass('aui-buttons');

			if (options) {
				options.id && group.attr('id', options.id);
				options.groupClass && group.addClass(options.groupClass);
			}

			for (let i = 0, length = components.length; i < length; i++) {
				group.append(components[i].render());
			}

			return group[0];
		};
	};

	/**
	 * Create a group of other controls. This group will be visually separate from other groups.
	 *
	 * @param contents an array of other components that should be in this group. (Don't nest groups.)
	 * @param options optional parameters for the group:
	 *   @param id the id for the group
	 *   @param groupClass the class for the group
	 */
	CustomToolbarComponents.SplitGroup = function (contents, options) {
		const components = contents;
		const dropDownOptions = (options && options.dropDownOptions) || {};

		function renderDropDown() {
			const id = dropDownOptions.id;
			const disabled = dropDownOptions.disabled;
			const dropDownContent = dropDownOptions.dropDownContent;
			const title = dropDownOptions.title;
			const alignment = dropDownOptions.alignment;

			const li = $('<div></div>')
				.addClass('toolbar-item')
				.addClass('toolbar-dropdown')
				.addClass('toolbar-splitbutton');
			id && li.attr('id', id);
			title && li.attr({ 'data-tooltip': title });
			alignment && li.data('dropdown-alignment', alignment);
			const parent = $('<div/>').addClass('aui-dd-parent');
			const a = $("<a href='#'></a>");
			a.addClass('toolbar-trigger aui-dd-trigger');

			if (disabled) {
				li.addClass('disabled');
				a.addClass('disabled');
			}

			const dropDownIcon = $('<span/>');
			dropDownIcon.addClass('icon').addClass('icon-dropdown');
			a.append(dropDownIcon);

			const dropDownContainer = $('<div/>').addClass('hidden').addClass('aui-dropdown');
			if (dropDownContent) {
				dropDownContainer.append(dropDownContent);
			}

			parent.append(a);
			parent.append(dropDownContainer);
			li.append(parent);

			return li[0];
		}

		/**
		 * Create and return the visual representation of the spacer.
		 */
		this.render = function () {
			const group = $('<div></div>');
			group.addClass('aui-buttons');

			if (options) {
				options.id && group.attr('id', options.id);
				options.groupClass && group.addClass(options.groupClass);
			}

			for (let i = 0, length = components.length; i < length; i++) {
				group.append(components[i].render());
			}

			// Add dropdown
			group.append(renderDropDown(options));

			options && options.postProcess && options.postProcess(group);

			return group[0];
		};
	};

	// WRM version needs this global set, cleanup in: CONFDEV-53025
	window.Confluence.Editor.Toolbar = {};
	window.Confluence.Editor.Toolbar.Components = CustomToolbarComponents;

	return CustomToolbarComponents;
}
